export const validationClass = {
    methods : {
        /**
         * Append the necessary bootstrap validation class to an element if
         * invalid
         *
         * @param  {Boolean} hasErrors
         *
         * @return {string}
         */
        validationClass(hasErrors) {
            return hasErrors ? 'is-invalid' : null;
        },          
    }
}